export default {
  SET_CODES_BY_CODEGRUPPEN (state, values) {
    state.codes = values
  },
  SET_CORRESPONDENCE (state, value) {
    state.correspondence = value
  },
  SET_DOCUMENTS_BY_GESUCHSART (state, value) {
    state.documents = value
  },
  SET_KONTOART (state, value) {
    state.kontoart = value
  },
  SET_COUNTRIES (state, value) {
    state.countries = value
  },
  SET_PROJEKTABSCHLUSS_SELECTION (state, value) {
    state.projektabschlussSelection = value
  },
  SET_DOCUMENTS_BY_GESUCHSART_PROJEKTABSCHLUSS (state, value) {
    state.documentsProjektabschluss = value
  }
}
